import React from "react";
import Wix from "Wix";
import "./DriveItemFullScreen.scss";
import Loader from "../loading/Loader";
import {getFileByFileId} from '../../api/GoogleDriveApi';
import parameters from '../../../config/parameters';
import { connect } from "react-redux";
import setDataPublic from '../../../actions/dataPublicActions';

const convertHex = (hex,opacity) => {
  hex = hex.replace('#','');
  let r = parseInt(hex.substring(0,2), 16);
  let g = parseInt(hex.substring(2,4), 16);
  let b = parseInt(hex.substring(4,6), 16);

  let result = 'rgba('+r+','+g+','+b+','+opacity/100+')';
  return result;
}

class DriveItemFullScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: props.src ? props.src : typeof props.fileId == "undefined" || props.fileId == parameters['DEFAULT_FILE'] ? parameters["DEFAULT_FILE_SRC"] : '',
      fileId: props.fileId ? props.fileId : parameters['DEFAULT_FILE'],
      editable: this.props.canEdit ? this.props.canEdit : 0,
      resourceKey:props.resourceKey || '' 
    }
    this.getFile = this.getFile.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if(newProps.canEdit !== this.state.editable){
      this.setState({fileId: newProps.fileId, noBorder: newProps.noBorder, editable: newProps.canEdit,resourceKey:newProps.resourceKey}, this.getFile)
    }
    if(newProps.src != this.state.src || newProps.fileId !== this.state.fileId) {
      this.setState({fileId: newProps.fileId,noBorder: newProps.noBorder, editable: newProps.canEdit, src: newProps.src, resourceKey: newProps.resourceKey})
    }
      if (newProps.styleOldSettings){
          this.divStyle = {
            border: '20px solid',
            borderRadius: newProps.styleOldSettings.cornerRadiusTopRight,
          };
      }
      
      else {
        this.divStyle = {}
      }
  }

  getFile() {
    const device = Wix.Utils.getDeviceType();
        getFileByFileId(this.state.fileId,this.state.resourceKey, (item) => {
          if (item) {
            let src = this.state.editable && item.mimeType.includes('google') && !item.mimeType.includes('form')
            ? item.alternateLink
            : item.embedLink;
            if(device === "mobile" && item.mimeType.includes('document') && !this.state.editable)
            {
              src =  `https://docs.google.com/viewer?srcid=${this.state.fileId}&pid=explorer&efh=false&a=v&chrome=false&embedded=true`;
              //src = `https://drive.google.com/thumbnail?id=${this.state.fileId}&sz=w280`;
           }
            src = src.replace(/ *a\/[^/]*\/ */g, "");
            this.setState({src: src, editable: this.props.canEdit})
          }
        },false)
     // }
  }
  
  render() {
    let src = this.state.src;
      
    return (
      src ? 
        <div
          style={this.divStyle}
          key={this.state.fileId}
          ref={node => this.iframe = node} 
          className={"div-iframe div-full-screen" }
          onClick={this.props.onClick}
        >
          {this.props.closeEnabled ? <button> Close </button> : null}

          <iframe 
              src={src} 
              style={{visibility: this.state.load ? 'visible' : 'hidden', width: window.innerWidth }}
              onLoad={() => {this.setState({load: true});this.iframe.style.visibility = 'visible'}} 
              className="iframe-full" 
              title="My item" 
              width={window.innerWidth}
          />
          </div> 
        :  
        <div className='wix-style-sample'>
          <Loader /> 
        </div>
    );
  }
}


const mapStateToProps = state => ({
  canEdit: state.widgetReducer.canEdit,
  dataPublic: state.dataPublicReducer.dataPublic
});

const mapDispatchToProps = dispatch => ({
     setDataPublic: (dataPublic) => dispatch(setDataPublic(dataPublic))
});
export default connect(mapStateToProps,mapDispatchToProps)(DriveItemFullScreen);


// WEBPACK FOOTER //
// ./src/widget/components/driveItemFullScreen/DriveItemFullScreen.js